import { render, staticRenderFns } from "./UiStickyActions.vue?vue&type=template&id=e6621b04&scoped=true"
import script from "./UiStickyActions.vue?vue&type=script&lang=js"
export * from "./UiStickyActions.vue?vue&type=script&lang=js"
import style0 from "./UiStickyActions.vue?vue&type=style&index=0&id=e6621b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6621b04",
  null
  
)

export default component.exports